// extracted by mini-css-extract-plugin
export var customSelectBox = "CustomSelect-module--customSelectBox--6ab3c";
export var customSelectWrapper = "CustomSelect-module--customSelectWrapper--98ea6";
export var lmsScrollbar = "CustomSelect-module--lms-scrollbar--ae33b";
export var selectDropdown = "CustomSelect-module--selectDropdown--e93a5";
export var selectLabel = "CustomSelect-module--selectLabel--beabc";